import BaseApi from './BaseApi';

/**
 * LINE問い合わせ最新チャット情報取得API。
 */
class SendMessageToKaiinApi extends BaseApi {
  async send(companyId: string, message: string) {
    return await this.execute('sendMessageToKaiinApi', {
      method: 'POST',
      body: {
        companyId,
        message
      }
    }).then(({ status }) => status === 1);
  }
}

export default SendMessageToKaiinApi;
